import classNames from 'classnames';
import { PropsWithChildren } from 'react';

import { NavBar } from '@/components';
import { AnimatePresenceComponent } from '@/components/AnimatePresenceComponent';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import ROUTES from '@/router/routes';

interface Props {
  title?: string;
  isLogin?: boolean;
}

export const AuthLayout = (props: PropsWithChildren<Props>) => {
  const { children, isLogin, title } = props;
  const { isDesktop } = useIsDesktop();

  const className = classNames({
    'bg-auth flex-1 flex items-center justify-center': isDesktop || isLogin,
    'flex items-center flex-1': !isLogin && isDesktop,
  });

  return (
    <NavBar
      mobile={
        !isLogin
          ? {
              centerContent: {
                title,
              },
              leftContent: {
                displayLogo: true,
              },
              rightContent: {
                closeMenuActionUrl: ROUTES.basePath,
              },
            }
          : undefined
      }
    >
      <main className={className}>
        {isDesktop ? (
          <AnimatePresenceComponent isLoaded={true}>
            {children}
          </AnimatePresenceComponent>
        ) : (
          <div className="px-6 pt-5">
            <AnimatePresenceComponent isLoaded={true}>
              {children}
            </AnimatePresenceComponent>
          </div>
        )}
      </main>
    </NavBar>
  );
};
